import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";

//import Controls from "./components/controls";
import { BasicContext } from './context/BasicContext'

import WebServiceContext from "./WebService/ServiceContext";

import CardList from "./course/CardList";
import CardOtsList from "./course/CardOtsList";
import Dashbaord from "./course/Dashbaord";
import Menu from "./course/Menu";
import State from "./course/State";
import Exam from "./exam";


let sURL = new URL(window.location.href);
//console.log(window.location.href)
sURL.searchParams.get('pid');

export default () => {
    const bc = useContext(BasicContext)
    
    useEffect(()=>{

        if(sURL.searchParams.get('pid') != null){
            bc.setPID(sURL.searchParams.get('pid') as string)
        }
        
        if(sURL.searchParams.get('bid') != null){
            bc.setBID(sURL.searchParams.get('bid') as string)
        }
        
        if(sURL.searchParams.get('type') != null){
            bc.setActType(sURL.searchParams.get('type') as string)
        }

        if(sURL.searchParams.get('Class1') != null){
            bc.setClass1(sURL.searchParams.get('Class1') as string)
        }

        if(sURL.searchParams.get('Class2') != null){
            bc.setClass2(sURL.searchParams.get('Class2') as string)
        }  

        if(sURL.searchParams.get('actid') != null){
            bc.setActID(sURL.searchParams.get('actid') as string)
        }

        if(sURL.searchParams.get('examPaper') != null){
            bc.setExamPaper(sURL.searchParams.get('examPaper') as string)
        }

        if(sURL.searchParams.get('actid') != null){
            bc.setActID((sURL.searchParams.get('actid') as string).toUpperCase())
        }   
        
        
        return
    },[])

    return (
        <div id="content-area">
            <Menu/>
            {
                (bc.PID == "exam" && bc.ExamPaper)? //正式
                //(bc.PID == "exam" )?//測試
                    <Exam/>:
                bc.PID == "Dashbaord"?
                    <Dashbaord/>:
                bc.PID == "list"?
                    <CardList/>:
                (bc.PID == "state1" || bc.PID == "state2")?
                    <State/>:
                bc.PID == "event"?
                    <CardOtsList/>:
                bc.PID == "lession"?
                    <CardOtsList/>:
                bc.PID == "record"?
                    "record":
                    <Dashbaord/>
            }
        </div>
    )

};
